import React, { useState, useEffect, useRef } from 'react';
import { Paper, TextField, Button, Box, Typography, ToggleButton, ToggleButtonGroup, Switch, FormControlLabel } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import dayjs from 'dayjs';
import { useAuth } from '../components/AuthContext';
import { API_BASE_URL } from '../components/api.js';

const VegetaisPedido = () => {
  const [mediaRowDataOriginal, setMediaRowDataOriginal] = useState([]);
  const [fator, setFator] = useState('FATOR');
  const [dataPedido, setDataPedido] = useState(dayjs());
  const [dataEntrega, setDataEntrega] = useState(dayjs());
  const [pedidoAte, setPedidoAte] = useState(dayjs());
  const [quantidade, setQuantidade] = useState(4);
  const [rowData, setRowData] = useState([]);
  const [relatorioRowData, setRelatorioRowData] = useState([]);
  const [mediaRowData, setMediaRowData] = useState([]);
  const [mediaRowDataOld, setMediaRowDataOld] = useState([]);
  const [tabelaCalculosData, setTabelaCalculosData] = useState([]);
  const [textoObservacoes, setTextoObservacoes] = useState('');
  const [usarEstatistica, setUsarEstatistica] = useState(false);
  // FIX 2: estatisticaData agora tem 3 linhas
  const [estatisticaData, setEstatisticaData] = useState([
    { estatistica: 'Média + Desvio Padrão', tomate: '0.000', cebola: '0.000', pimentao: '0.000', pepino: '0.000', alface: '0.000' },
    { estatistica: 'Média',                 tomate: '0.000', cebola: '0.000', pimentao: '0.000', pepino: '0.000', alface: '0.000' },
    { estatistica: 'Média - Desvio Padrão', tomate: '0.000', cebola: '0.000', pimentao: '0.000', pepino: '0.000', alface: '0.000' },
  ]);
  // FIX 2: qual linha está selecionada (índice 0, 1 ou 2)
  const [selectedEstatistica, setSelectedEstatistica] = useState(1);
  const estatisticaGridRef = useRef(null);

  const fatorAnterior = useRef(fator);
  const { authenticatedFetch, logout } = useAuth();
  const isInitialMount = useRef(true);
  const quantidadeRef = useRef(quantidade);

  const columnDefs = [
    { headerName: 'Vegetal', field: 'vegetal', width: 88, resizable: true },
    { headerName: 'Pedido', field: 'quantidade', width: 75, resizable: true, cellStyle: { textAlign: 'center'}, editable: true },
  ];

  const calculosColumnDefs = [
    { headerName: '', field: 'categoria', width: 80, pinned: 'left', resizable: true },
    { headerName: 'Tomate', field: 'tomate', width: 80, resizable: true },
    { headerName: 'Cebola', field: 'cebola', width: 80, resizable: true },
    { headerName: 'Pimentão', field: 'pimentao', width: 95, resizable: true },
    { headerName: 'Pepino', field: 'pepino', width: 80, resizable: true },
    { headerName: 'Alface', field: 'alface', width: 80, resizable: true },
  ];

  // FIX 2: coluna de seleção adicionada via checkboxSelection
  const estatisticaColumnDefs = [
    {
      headerName: '',
      field: '_sel',
      width: 40,
      checkboxSelection: true,
      headerCheckboxSelection: false,
      pinned: 'left',
      resizable: false,
      editable: false,
    },
    { headerName: 'Estatística', field: 'estatistica', width: 170, pinned: 'left', resizable: true, editable: false },
    { headerName: 'Tomate',   field: 'tomate',   width: 90, resizable: true, editable: true },
    { headerName: 'Cebola',   field: 'cebola',   width: 90, resizable: true, editable: true },
    { headerName: 'Pimentão', field: 'pimentao', width: 95, resizable: true, editable: true },
    { headerName: 'Pepino',   field: 'pepino',   width: 90, resizable: true, editable: true },
    { headerName: 'Alface',   field: 'alface',   width: 90, resizable: true, editable: true },
  ];

  const relatorioColumnDefs = [
    { headerName: 'Dia da Semana', field: 'Dia da Semana', pinned: 'left', width: 130, resizable: true },
    { headerName: 'Tomate',     field: 'tomate',    width: 80, resizable: true },
    { headerName: 'Cebola',     field: 'cebola',    width: 80, resizable: true },
    { headerName: 'Pimentão',   field: 'pimentao',  width: 95, resizable: true },
    { headerName: 'Pepino',     field: 'pepino',    width: 80, resizable: true },
    { headerName: 'Alface',     field: 'alface',    width: 80, resizable: true },
    { headerName: 'Pães',       field: 'Paes',      width: 80, resizable: true },
    { headerName: 'N Tomate',   field: 'Ntomate',   width: 90, resizable: true },
    { headerName: 'N Cebola',   field: 'Ncebola',   width: 90, resizable: true },
    { headerName: 'N Pimentão', field: 'Npimentao', width: 105, resizable: true },
    { headerName: 'N Pepino',   field: 'Npepino',   width: 90, resizable: true },
    { headerName: 'N Alface',   field: 'Nalface',   width: 90, resizable: true },
    { headerName: 'N Pães',     field: 'Npães',     width: 85, resizable: true },
  ];

  const mediaColumnDefs = [
    { headerName: 'Dia da Semana', field: 'Dia da Semana', pinned: 'left', width: 125, resizable: true },
    { headerName: 'Tomate',   field: 'Ntomate',     width: 75, resizable: true },
    { headerName: 'Cebola',   field: 'Ncebola',     width: 75, resizable: true },
    { headerName: 'Pimentão', field: 'Npimentao',   width: 90, resizable: true },
    { headerName: 'Pepino',   field: 'Npepino',     width: 75, resizable: true },
    { headerName: 'Alface',   field: 'Nalface',     width: 75, resizable: true },
    { headerName: 'Pães',     field: 'Paes_do_dia', width: 80, resizable: true, editable: true },
  ];

  const defaultColDef = { minWidth: 60, maxWidth: 300 };

  const onFirstDataRendered = (params) => {
    if (!params?.columnApi) return;
    const columnCount = params.columnApi.getAllColumns().length;
    if (columnCount <= 2) {
      const allColumnIds = params.columnApi.getAllColumns().map((col) => col.getId());
      if (allColumnIds.length > 0) {
        params.columnApi.autoSizeColumns(allColumnIds, false);
      }
    }
  };

  // FIX 2: seleciona a primeira linha da tabela de estatística após renderizar
  const onEstatisticaFirstDataRendered = (params) => {
    onFirstDataRendered(params);
    
    // Aguarda o AG Grid terminar o ciclo de renderização visual dos checkboxes
    setTimeout(() => {
      // Busca a linha pelo índice 1 (Média) e força a seleção completa com o checkbox
      const mediaNode = params.api.getDisplayedRowAtIndex(1);
      if (mediaNode) {
        mediaNode.setSelected(true);
      }
    }, 50);
  };

  const onCellValueChanged = (event) => {
    const newData = rowData.map(row => {
      if (row.vegetal === event.data.vegetal) {
        return { ...row, quantidade: event.newValue };
      }
      return row;
    });
    setRowData(newData);
  };

  const handleSavePedido = async () => {
    const payload = {
      data_entrega: dataEntrega.format('YYYY-MM-DD'),
      fator: fator,
      dados: rowData,
    };

    try {
      const response = await authenticatedFetch('' + API_BASE_URL + '/api/vegetais-pedido-salvar/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.status === 401) {
        console.error('Erro 401: Token inválido. Redirecionando para o login.');
        return;
      }

      if (!response.ok) throw new Error('Network response was not ok');

      const result = await response.json();
      console.log('Pedido salvo com sucesso:', result);
      alert('Pedido salvo com sucesso!');
    } catch (error) {
      if (error.message.includes('Token')) {
        logout();
      } else {
        alert('Erro ao salvar o pedido.' + error.message);
      }
    }
  };

  const fetchDadosPrevisao = async () => {
    if (!dataPedido?.isValid() || !dataEntrega?.isValid() || !pedidoAte?.isValid()) return;

    const payload = {
      data_pedido: dataPedido.format('YYYY-MM-DD'),
      data_entrega: dataEntrega.format('YYYY-MM-DD'),
      pedido_ate: pedidoAte.format('YYYY-MM-DD'),
      fator: fator,
      quantidade: quantidade,
    };

    try {
      const response = await authenticatedFetch('' + API_BASE_URL + '/api/vegetais-pedido-previsao/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Erro ao buscar dados do backend.');
      const result = await response.json();

      setRelatorioRowData(result.relatorio_principal);
      setMediaRowData(result.media_semanal);
      setMediaRowDataOriginal(JSON.parse(JSON.stringify(result.media_semanal)));
      setTabelaCalculosData(result.tabela_calculos || []);

      const newRowData = result.compras.map(item => ({
        vegetal: item.vegetal,
        quantidade: item.quantidade
      }));
      setRowData(newRowData);
    } catch (error) {
      if (error.message.includes('Token')) logout();
      else alert('Erro ao buscar os dados.' + error.message);
    }
  };

  const fetchDadosQuantidade = async (novaQuantidade) => {
    const payload = { quantidade: novaQuantidade };

    try {
      const response = await authenticatedFetch('' + API_BASE_URL + '/api/vegetais-pedido-media/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Erro ao buscar dados de quantidade.');
      const result = await response.json();

      setMediaRowData(result.mediaRowData);
      setMediaRowDataOriginal(JSON.parse(JSON.stringify(result.mediaRowData)));
      setRelatorioRowData(result.relatorioRowData);

      const novosCalculos = recalcularPrevisao(result.mediaRowData);
      setTabelaCalculosData(novosCalculos);
    } catch (error) {
      if (error.message.includes('Token')) logout();
      else alert('Erro ao buscar dados de quantidade: ' + error.message);
    }
  };

  const fetchDadosDatas = async () => {
    if (!dataPedido?.isValid() || !dataEntrega?.isValid() || !pedidoAte?.isValid()) return;
    if (!mediaRowData || mediaRowData.length === 0) return;

    const payload = {
      data_pedido: dataPedido.format('YYYY-MM-DD'),
      data_entrega: dataEntrega.format('YYYY-MM-DD'),
      pedido_ate: pedidoAte.format('YYYY-MM-DD'),
      mediaRowData: mediaRowData,
      fator: fator
    };

    try {
      const response = await authenticatedFetch('' + API_BASE_URL + '/api/vegetais-pedido-datas/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error('Erro ao buscar dados de datas.');
      const result = await response.json();
      setTabelaCalculosData(result.tabelaCalculosData);
      if (result.rowData) setRowData(result.rowData);
    } catch (error) {
      if (error.message.includes('Token')) logout();
      else alert('Erro ao buscar dados de datas: ' + error.message);
    }
  };

  const recalcularPrevisao = (mediaData) => {
    if (!dataPedido?.isValid() || !dataEntrega?.isValid() || !pedidoAte?.isValid()) {
      return tabelaCalculosData;
    }

    const produtos = ['tomate', 'cebola', 'pimentao', 'pepino', 'alface'];

    const diasSaida = [];
    let currentDateSaida = dataPedido.clone();
    const umDiaAntesEntrega = dataEntrega.subtract(1, 'day');
    while (currentDateSaida.isBefore(umDiaAntesEntrega) || currentDateSaida.isSame(umDiaAntesEntrega, 'day')) {
      const diaSemana = currentDateSaida.locale('pt-br').format('dddd');
      diasSaida.push(diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1));
      currentDateSaida = currentDateSaida.add(1, 'day');
    }

    const novaSaida = { categoria: 'Saída' };
    produtos.forEach(produto => {
      let soma = 0;
      diasSaida.forEach(dia => {
        const rowDia = mediaData.find(row => row['Dia da Semana'] === dia);
        if (rowDia && rowDia['N' + produto]) soma += parseFloat(rowDia['N' + produto]) || 0;
      });
      novaSaida[produto] = parseFloat(soma.toFixed(3));
    });

    const diasPrevisao = [];
    let currentDatePrevisao = dataEntrega.clone();
    while (currentDatePrevisao.isBefore(pedidoAte) || currentDatePrevisao.isSame(pedidoAte, 'day')) {
      const diaSemana = currentDatePrevisao.locale('pt-br').format('dddd');
      diasPrevisao.push(diaSemana.charAt(0).toUpperCase() + diaSemana.slice(1));
      currentDatePrevisao = currentDatePrevisao.add(1, 'day');
    }

    const novaPrevisao = { categoria: 'Previsão' };
    produtos.forEach(produto => {
      let soma = 0;
      diasPrevisao.forEach(dia => {
        const rowDia = mediaData.find(row => row['Dia da Semana'] === dia);
        if (rowDia && rowDia['N' + produto]) soma += parseFloat(rowDia['N' + produto]) || 0;
      });
      novaPrevisao[produto] = parseFloat(soma.toFixed(3));
    });

    let updatedCalculos = tabelaCalculosData.map(row => {
      if (row.categoria === 'Saída') return novaSaida;
      if (row.categoria === 'Previsão') return novaPrevisao;
      return row;
    });

    updatedCalculos = updatedCalculos.map(row => {
      if (row.categoria === 'Sobra') {
        const linhaEstoque = updatedCalculos.find(r => r.categoria === 'Estoque');
        const linhaSaida = updatedCalculos.find(r => r.categoria === 'Saída');
        const novaSobra = { categoria: 'Sobra' };
        produtos.forEach(produto => {
          const estoque = linhaEstoque?.[produto] || 0;
          const saida = linhaSaida?.[produto] || 0;
          novaSobra[produto] = parseFloat(Math.max(estoque - saida, 0).toFixed(3));
        });
        return novaSobra;
      }
      return row;
    });

    updatedCalculos = updatedCalculos.map(row => {
      if (row.categoria === 'Pedido') {
        const linhaSobra = updatedCalculos.find(r => r.categoria === 'Sobra');
        const linhaPrevisao = updatedCalculos.find(r => r.categoria === 'Previsão');
        const novoPedido = { categoria: 'Pedido' };
        produtos.forEach(produto => {
          const previsao = linhaPrevisao?.[produto] || 0;
          const sobra = linhaSobra?.[produto] || 0;
          novoPedido[produto] = parseFloat(Math.max(previsao - sobra, 0).toFixed(3));
        });
        return novoPedido;
      }
      return row;
    });

    return updatedCalculos;
  };

  const onMediaCellValueChanged = (event) => {
    if (event.colDef.field === 'Paes_do_dia') {
      const newValue = parseFloat(event.newValue) || 0;
      const produtos = ['Ntomate', 'Ncebola', 'Npimentao', 'Npepino', 'Nalface'];

      const updatedMediaRowData = mediaRowData.map(row => {
        if (row['Dia da Semana'] === event.data['Dia da Semana']) {
          const updatedRow = { ...row };

          if (usarEstatistica) {
            // FIX 2: usa a linha selecionada, não sempre [0]
            const stats = estatisticaData[selectedEstatistica];
            updatedRow['Ntomate']   = ((parseFloat(stats.tomate)   || 0) * newValue).toFixed(3);
            updatedRow['Ncebola']   = ((parseFloat(stats.cebola)   || 0) * newValue).toFixed(3);
            updatedRow['Npimentao'] = ((parseFloat(stats.pimentao) || 0) * newValue).toFixed(3);
            updatedRow['Npepino']   = ((parseFloat(stats.pepino)   || 0) * newValue).toFixed(3);
            updatedRow['Nalface']   = ((parseFloat(stats.alface)   || 0) * newValue).toFixed(3);
          } else {
            const rowOriginal = mediaRowDataOriginal.find(r => r['Dia da Semana'] === row['Dia da Semana']);
            if (!rowOriginal) { alert('Erro: não foi possível encontrar dados originais.'); return row; }
            const paesOriginal = parseFloat(rowOriginal['Paes_do_dia']) || 0;
            if (paesOriginal === 0) { alert('Não é possível recalcular com valor original de Pães igual a 0.'); return row; }
            produtos.forEach(produto => {
              const valorOriginal = parseFloat(rowOriginal[produto]) || 0;
              updatedRow[produto] = ((valorOriginal / paesOriginal) * newValue).toFixed(3);
            });
          }

          updatedRow['Paes_do_dia'] = newValue.toFixed(1);
          return updatedRow;
        }
        return row;
      });

      setMediaRowData(updatedMediaRowData);
      setTabelaCalculosData(recalcularPrevisao(updatedMediaRowData));
    }
  };

  // FIX 2: recebe statsData e selectedIdx para usar a linha correta
  const aplicarEstatistica = (statsData = estatisticaData, selectedIdx = selectedEstatistica) => {
    const stats = statsData[selectedIdx];

    const updatedMediaRowData = mediaRowData.map(row => {
      const paes = parseFloat(row['Paes_do_dia']) || 0;
      return {
        ...row,
        'Ntomate':   (paes * (parseFloat(stats.tomate)   || 0)).toFixed(3),
        'Ncebola':   (paes * (parseFloat(stats.cebola)   || 0)).toFixed(3),
        'Npimentao': (paes * (parseFloat(stats.pimentao) || 0)).toFixed(3),
        'Npepino':   (paes * (parseFloat(stats.pepino)   || 0)).toFixed(3),
        'Nalface':   (paes * (parseFloat(stats.alface)   || 0)).toFixed(3),
      };
    });

    setMediaRowData(updatedMediaRowData);
    setTabelaCalculosData(recalcularPrevisao(updatedMediaRowData));
  };

  const handleUsarEstatisticaChange = (checked) => {
    setUsarEstatistica(checked);
    if (checked) {
      setMediaRowDataOld([...mediaRowData]);
      aplicarEstatistica(estatisticaData, selectedEstatistica);
    } else {
      setMediaRowData(mediaRowDataOld);
      setTabelaCalculosData(recalcularPrevisao(mediaRowDataOld));
    }
  };

  // FIX 2: atualiza a linha correta na tabela de estatísticas
  const onEstatisticaCellValueChanged = (event) => {
    const updatedEstatistica = [...estatisticaData];
    const rowIndex = updatedEstatistica.findIndex(r => r.estatistica === event.data.estatistica);
    if (rowIndex === -1) return;

    updatedEstatistica[rowIndex] = {
      ...updatedEstatistica[rowIndex],
      [event.colDef.field]: parseFloat(event.newValue).toFixed(3)
    };
    setEstatisticaData(updatedEstatistica);

    if (usarEstatistica) {
      aplicarEstatistica(updatedEstatistica, selectedEstatistica);
    }
  };

  // FIX 2: callback quando o usuário clica em outra linha da tabela de estatísticas
  const onEstatisticaSelectionChanged = (event) => {
    const selectedRows = event.api.getSelectedRows();
    if (selectedRows.length === 0) return;

    const idx = estatisticaData.findIndex(r => r.estatistica === selectedRows[0].estatistica);
    if (idx === -1) return;

    setSelectedEstatistica(idx);

    if (usarEstatistica) {
      aplicarEstatistica(estatisticaData, idx);
    }
  };

  const fetchProdutos = async () => {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/vegetais-pedido-consulta/`, { method: 'GET' });
      if (!response.ok) throw new Error('Erro na resposta da rede ao buscar a lista de produtos.');
      const result = await response.json();
      setRowData(result.pedidos.map(item => ({ vegetal: item.vegetal, quantidade: item.quantidade })));
    } catch (error) {
      if (error.message.includes('Token')) logout();
      else alert('Erro ao buscar a lista de produtos:' + error.message);
    }
  };

  // FIX 2: busca tabela completa com as 3 linhas (média+dp, média, média-dp)
  // O backend deve retornar: { media_mais_dp, media, media_menos_dp } com campos tomate, cebola, pimentao, pepino, alface
  const fetchMediaDesvio = async () => {
    try {
      const response = await authenticatedFetch(`${API_BASE_URL}/api/vegetais-pedido-media-desvio/`, { method: 'GET' });
      if (!response.ok) throw new Error('Erro ao buscar média + desvio padrão.');
      const result = await response.json();

      const toRow = (label, obj) => ({
        estatistica: label,
        tomate:   (obj?.tomate   || '0.000'),
        cebola:   (obj?.cebola   || '0.000'),
        pimentao: (obj?.pimentao || '0.000'),
        pepino:   (obj?.pepino   || '0.000'),
        alface:   (obj?.alface   || '0.000'),
      });

      setEstatisticaData([
        toRow('Média + Desvio Padrão', result.media_mais_dp),
        toRow('Média',                 result.media),
        toRow('Média - Desvio Padrão', result.media_menos_dp),
      ]);
    } catch (error) {
      if (error.message.includes('Token')) logout();
      else console.error('Erro ao buscar média + desvio padrão:', error.message);
    }
  };

  useEffect(() => {
    fetchProdutos();
    fetchMediaDesvio();
  }, []);

  useEffect(() => {
    if (isInitialMount.current) {
      if (dataPedido?.isValid() && dataEntrega?.isValid() && pedidoAte?.isValid()) {
        fetchDadosPrevisao();
        isInitialMount.current = false;
      }
    }
  }, [dataPedido, dataEntrega, pedidoAte]);

  useEffect(() => {
    if (!isInitialMount.current && quantidade !== quantidadeRef.current) {
      quantidadeRef.current = quantidade;
      fetchDadosQuantidade(quantidade);
    }
  }, [quantidade]);

  useEffect(() => {
    if (!isInitialMount.current) {
      fetchDadosDatas();
    }
  }, [dataPedido, dataEntrega, pedidoAte]);

  // FIX 1: quando as 3 datas são iguais, mudar para KG (era FATOR antes — incorreto)
  useEffect(() => {
    const isSameDay = dataPedido?.isSame(dataEntrega, 'day') && dataPedido?.isSame(pedidoAte, 'day');
    if (isSameDay) {
      setFator('KG');
    }
    else setFator('FATOR');
  }, [dataPedido, dataEntrega, pedidoAte]);

  const handleFatorChange = (event, newFator) => {
    if (newFator !== null) setFator(newFator);
  };

  useEffect(() => {
    if (!isInitialMount.current && rowData.length > 0 && fatorAnterior.current !== fator) {
      const updatedRowData = rowData.map(item => {
        if (item.vegetal.toLowerCase() === 'alface' && item.quantidade > 0) {
          let novaQuantidade = item.quantidade;
          if (fatorAnterior.current === 'FATOR' && fator === 'KG') novaQuantidade = item.quantidade * 0.8;
          else if (fatorAnterior.current === 'KG' && fator === 'FATOR') novaQuantidade = item.quantidade / 0.8;
          return { ...item, quantidade: parseFloat(novaQuantidade.toFixed(3)) };
        }
        return item;
      });
      setRowData(updatedRowData);
      fatorAnterior.current = fator;
    }
  }, [fator]);

  useEffect(() => {
    const agora = new Date();
    const hora = agora.getHours();
    let saudacao = hora < 12 ? 'Bom dia, ' : hora < 18 ? 'Boa tarde, ' : 'Boa noite, ';

    const diaDaSemana = new Intl.DateTimeFormat('pt-BR', { weekday: 'long' }).format(dataEntrega.toDate());
    const dataFormatada = new Intl.DateTimeFormat('pt-BR').format(dataEntrega.toDate());

    const vegetaisData = {};
    rowData.forEach(item => { vegetaisData[item.vegetal.toLowerCase()] = item; });

    let novoTextoObservacoes = '';

    if (fator === 'FATOR') {
      novoTextoObservacoes = `${saudacao}

Pedido para ${diaDaSemana} (${dataFormatada})
Rodoviária:
${vegetaisData.tomate?.quantidade || 0} KG de Tomate
${vegetaisData.cebola?.quantidade || 0} KG de Cebola
${vegetaisData.pimentao?.quantidade || vegetaisData.pimentão?.quantidade || 0} KG de Pimentão
${vegetaisData.pepino?.quantidade || 0} KG de Pepino
${vegetaisData.alface?.quantidade || 0} Alface (0,800kg)

Obrigado`;
    } else {
      const itensParaComprar = [
        (vegetaisData.tomate?.quantidade > 0)    && `${vegetaisData.tomate.quantidade} KG de Tomate`,
        (vegetaisData.cebola?.quantidade > 0)    && `${vegetaisData.cebola.quantidade} KG de Cebola`,
        (vegetaisData.pimentao?.quantidade > 0 || vegetaisData.pimentão?.quantidade > 0) &&
          `${vegetaisData.pimentao?.quantidade || vegetaisData.pimentão?.quantidade} KG de Pimentão`,
        (vegetaisData.pepino?.quantidade > 0)    && `${vegetaisData.pepino.quantidade} KG de Pepino`,
        (vegetaisData.alface?.quantidade > 0)    && `${vegetaisData.alface.quantidade} Alface`,
      ].filter(Boolean);

      novoTextoObservacoes = `${saudacao}

Temos que comprar:
${itensParaComprar.join('\n')}`;
    }

    setTextoObservacoes(novoTextoObservacoes);
  }, [rowData, fator, dataEntrega]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <Box sx={{ flexGrow: 1, padding: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>

        {/* Linha 1 - Controles */}
        <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 600, alignSelf: 'flex-start' }}>
          <Box display="flex" gap={2} flexWrap={{ xs: 'wrap', md: 'nowrap' }} alignItems="center">
            <DatePicker label="Data do pedido"  value={dataPedido}  onChange={setDataPedido} />
            <DatePicker label="Data da entrega" value={dataEntrega} onChange={setDataEntrega} />
            <DatePicker label="Pedido para até" value={pedidoAte}   onChange={setPedidoAte} />
            <TextField
              label="Quantidade"
              type="number"
              value={quantidade}
              onChange={(e) => {
                let newValue = parseInt(e.target.value, 10);
                if (isNaN(newValue) || newValue < 1) newValue = 1;
                if (newValue > 24) newValue = 24;
                setQuantidade(newValue);
              }}
              sx={{
                width: 100,
                '& input[type="number"]': { '-moz-appearance': 'textfield' },
                '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                  '-webkit-appearance': 'inner-spin-button',
                  opacity: 1,
                },
              }}
              slotProps={{ input: { min: 1, max: 24 } }}
            />
            <ToggleButtonGroup value={fator} exclusive onChange={handleFatorChange} sx={{ height: 56 }}>
              <ToggleButton value="FATOR"><Typography variant="body2">FATOR</Typography></ToggleButton>
              <ToggleButton value="KG"><Typography variant="body2">KG</Typography></ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Paper>

        {/* Linha 2 - Tabela rowData + Tabela de Cálculos */}
        <Box display="flex" gap={3} flexWrap={{ xs: 'wrap', md: 'nowrap' }}>
          <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 170 }}>
            <Box className="ag-theme-alpine" sx={{ maxHeight: 250, width: 'auto', minWidth: 170 }}>
              <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                defaultColDef={defaultColDef}
                domLayout="autoHeight"
                onFirstDataRendered={onFirstDataRendered}
                onCellValueChanged={onCellValueChanged}
              />
            </Box>
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="contained" color="primary" onClick={handleSavePedido}>
                Salvar Pedido
              </Button>
            </Box>
          </Paper>

          <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 500 }}>
            <Box className="ag-theme-alpine" sx={{ maxHeight: 250, width: 'auto', minWidth: 500 }}>
              <AgGridReact
                columnDefs={calculosColumnDefs}
                rowData={tabelaCalculosData}
                defaultColDef={defaultColDef}
                domLayout="autoHeight"
                onFirstDataRendered={onFirstDataRendered}
              />
            </Box>
          </Paper>
        </Box>

        {/* Linha 3 - Tabela mediaRowData + TextField */}
        <Box display="flex" gap={3} flexWrap={{ xs: 'wrap', md: 'nowrap' }}>
          <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 520 }}>
            <Box className="ag-theme-alpine" sx={{ maxHeight: 250, width: 'auto', minWidth: 600 }}>
              <AgGridReact
                columnDefs={mediaColumnDefs}
                rowData={mediaRowData}
                defaultColDef={defaultColDef}
                domLayout="autoHeight"
                onFirstDataRendered={onFirstDataRendered}
                onCellValueChanged={onMediaCellValueChanged}
              />
            </Box>
          </Paper>

          <Paper elevation={3} sx={{ padding: 1, width: 'auto', minWidth: 300, height: 250 }}>
            <TextField
              multiline
              fullWidth
              variant="outlined"
              value={textoObservacoes}
              onChange={(e) => setTextoObservacoes(e.target.value)}
              placeholder="Observações..."
              sx={{
                height: '100%',
                '& .MuiOutlinedInput-root': { height: '100%', alignItems: 'flex-start', fontSize: '13px' },
                '& .MuiOutlinedInput-input': { height: '100% !important', overflow: 'auto !important', fontSize: '0.875rem' }
              }}
            />
          </Paper>
        </Box>

        {/* LINHA - Tabela de Estatísticas + Switch */}
        <Box display="flex" gap={3} alignItems="flex-start" flexWrap={{ xs: 'wrap', md: 'nowrap' }}>
          <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 520 }}>
            {/* FIX 2: label explica que basta clicar na linha para selecionar */}
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
              Clique na linha para selecionar qual estatística usar (selecionada: <strong>{estatisticaData[selectedEstatistica]?.estatistica}</strong>)
            </Typography>
            {/* FIX 2: altura aumentada para acomodar 3 linhas */}
            <Box className="ag-theme-alpine" sx={{ height: 120, width: 'auto', minWidth: 690 }}>
              <AgGridReact
                ref={estatisticaGridRef}
                columnDefs={estatisticaColumnDefs}
                rowData={estatisticaData}
                defaultColDef={defaultColDef}
                rowSelection="single"
                onFirstDataRendered={onEstatisticaFirstDataRendered}
                onCellValueChanged={onEstatisticaCellValueChanged}
                onSelectionChanged={onEstatisticaSelectionChanged}
              />
            </Box>
          </Paper>

          <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 200, height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <FormControlLabel
              control={
                <Switch
                  checked={usarEstatistica}
                  onChange={(e) => handleUsarEstatisticaChange(e.target.checked)}
                  color="primary"
                />
              }
              label="Usar Estatística"
            />
          </Paper>
        </Box>

        {/* Linha 4 - Tabela relatorioRowData */}
        <Paper elevation={3} sx={{ padding: 2, width: 'auto', minWidth: 1200, alignSelf: 'flex-start' }}>
          <Box className="ag-theme-alpine" sx={{ height: 400, width: 'auto', minWidth: 1200 }}>
            <AgGridReact
              columnDefs={relatorioColumnDefs}
              rowData={relatorioRowData}
              defaultColDef={defaultColDef}
              onFirstDataRendered={onFirstDataRendered}
            />
          </Box>
        </Paper>
      </Box>
    </LocalizationProvider>
  );
};

export default VegetaisPedido;